import React from 'react';

const IdVerification = () => {
  return (
    <section
      id="id-verification"
      className="max-w-7xl mx-auto py-24 bg-gradient-to-br from-white via-cyan-50/30 to-purple-50/30 relative overflow-hidden flex justify-center items-center"
    >
      <img
        src="/images/markid.jpg"
        alt="ID Verification"
        className="w-full h-full object-cover rounded-xl shadow-2xl"
      />
    </section>
  );
};

export default IdVerification;